
//import AlmostFullBanner from './Components/AlmostFullBanner';
import Banner from './Components/Banner';
import BonusSection from './Components/BonusSection';
import CoachIntroSection from './Components/CoachIntroSection';
import FaqAccordion from './Components/FaqAccordion';
import Footer from './Components/Footer';
import FutureSelf from './Components/FutureSelf';
import Masterclass from './Components/Masterclass';
import TestimonialVideos from './Components/TestimonialVideos';
import TopStudents from './Components/TopStudents';
import WhatsAppTestimonials from './Components/WhatsAppTestimonials';
import WorkshopCards from './Components/WorkshopCards';

function App() {
  return (
    <div className="App">
      <Banner/>
      <TopStudents/>
      <WorkshopCards/>
      <FutureSelf/>
      <Masterclass/>
      <TestimonialVideos/>
      <WhatsAppTestimonials/>
      <BonusSection/>
      <CoachIntroSection/>
      <FaqAccordion/>
      <Footer/>
      {/* <AlmostFullBanner/> */}
    </div>
  );
}

export default App;
